/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.create.detail.controllers', [
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.helpers'
])

.controller('CouponsCreateDetailController', ['$scope', '$state', '$q', 'ApiService', 'PermissionsService', 'HelpersService', 'CouponRedemptionLimitsService', function($scope, $state, $q, ApiService, PermissionsService, HelpersService, CouponRedemptionLimitsService) {

    $scope.couponsCreateDetail = {

      model: {},

      errorMessage: '',

      categories: [],

      coupons: [],

      accounts: [],

      isRedemptionEnabled: false,

      redemptionLimitCopy: CouponRedemptionLimitsService.copy,

      redemptionLimits: CouponRedemptionLimitsService.createForm(),

      redemptionLimitErrors: {},

      redemptionLimitsPayload: null,

      init: function() {
        var self = $scope.couponsCreateDetail,
            title = {
              title: 'Edit Coupon Details',
              buttonLeft: {
                label: 'Cancel',
                action: function() {
                  $state.go('application.coupons.list');
                }
              },
              buttonRight: {
                label: 'Save & Close',
                permissions: ['COUPONS_UPDATE'],
                action: function() {
                  $scope.couponsCreateDetail.complete(true);
                }
              }
            };
        
        $scope.$emit('Application::contentTitleChange', title);

        $scope.$on("CouponsCreateController::save", this.onSave);
        $scope.$on('$destroy', function() {
          self.isDestroyed = true;
        });
        $q.all([
          self.getCouponCategories(),
          self.getCoupons(),
          self.getCouponAccounts(),
          self.getCoupon($state.params.couponId)
        ]);

        CouponRedemptionLimitsService.isEnabled().then(this.onRedemptionFlag);
      },

      onRedemptionFlag: function(isEnabled) {
        var self = $scope.couponsCreateDetail;
        $scope.$applyAsync(function() {
          if (!self.isDestroyed) {
            self.isRedemptionEnabled = isEnabled;
          }
        });
      },

      checkPermissions: function(permission){
        return PermissionsService.check(permission);
      },

      getCoupon: function(id) {
        ApiService.coupons.detail(id).then(this.success.getCoupon, this.error.getCoupon);
      },

      refreshRedemptionState: function() {
        ApiService.coupons.detail(this.model.id).then(this.success.refreshRedemptionState, this.error.refreshRedemptionState);
      },

      onRedemptionLimitChange: function(key, field) {
        this.redemptionLimits[key] = field;
        delete this.redemptionLimitErrors[key];
      },

      formatOrderRedemptionCount: function() {
        return CouponRedemptionLimitsService.formatOrderRedemptionCount(
          this.model.orderRedemptionCount,
          this.model.orderRedemptionLimit
        );
      },

      validateRedemptionLimits: function() {
        var result;
        this.redemptionLimitErrors = {};
        this.redemptionLimitsPayload = null;
        if (!this.isRedemptionEnabled) {
          return true;
        }

        result = CouponRedemptionLimitsService.validate(this.redemptionLimits, {
          orderRedemptionCount: this.model.orderRedemptionCount
        });
        this.redemptionLimitErrors = result.fieldErrors;
        if (!result.isValid) {
          // A name/code banner from isPresent/isUnique takes precedence over the limits banner.
          this.errorMessage = this.errorMessage || result.bannerMessages[0] || '';
          return false;
        }

        this.redemptionLimitsPayload = result.payload;
        return true;
      },

      buildUpdatePayload: function() {
        if (this.redemptionLimitsPayload) {
          return angular.extend({}, this.model, this.redemptionLimitsPayload);
        }
        return this.model;
      },

      getCouponCategories: function() {
        ApiService.coupons.categories.list(HelpersService.getPaginator()).then(this.success.getCategories, this.error.getCategories);
      },

      getCoupons: function() {
        ApiService.coupons.list(HelpersService.getPaginator()).then(this.success.getCoupons, this.error.getCoupons);
      },

      getCouponAccounts: function() {
        var gridState = HelpersService.getPaginator({sortField : 'name'});
        ApiService.partners.list(gridState).then(this.success.getCouponAccounts, this.error.getCouponAccounts);
      },

      trim: function(s) {
        return s.replace(/\s+/g, '').toLowerCase();
      },

      isPresent: function(property) {
        this.errorMessage = '';
        if (this.trim(this.model[property]).length <= 0) {
          this.errorMessage = 'Please enter a valid '+property;
          return false;
        }
        return true;
      },

      isUnique: function(property) {
        var i, ii,
          trimmed,
          trimmedCurrent = this.trim(this.model[property]),
          r = true;
        if (!this.isPresent(property)) {
          r = false;
        } else {
          for (i=0,ii=this.coupons.length;i<ii;i++) {
            trimmed = this.trim(this.coupons[i][property]);
            if ( (trimmedCurrent === trimmed) && (this.model.id !== this.coupons[i].id) ) {
              r = false;
              this.errorMessage = 'A coupon with this '+property+' already exists.';
              break;
            }
          }
        }

        return r;

      },

      isValid: function() {
        var hasValidNameAndCode, hasValidLimits;
        if (!this.isSubmitted) {
          return true;
        }

        // Validate the limits even when name/code fail so their inline errors are always current.
        hasValidNameAndCode = this.isPresent('name') && this.isUnique('code');
        hasValidLimits = this.validateRedemptionLimits();

        return hasValidNameAndCode && hasValidLimits;
      },

      // Save & Continue passes its own saveAction; the step tabs broadcast without one (tab_change).
      onSave: function(e, data) {
        var self = $scope.couponsCreateDetail;
        self.next = data.state;
        self.complete(false, data.saveAction);
      },

      complete: function(close, saveAction) {
        var self = this,
          errorHandler = (close) ? this.error.saveAndClose : this.error.complete,
          successHandler = (close) ? this.success.saveAndClose : this.success.complete,
          trackedSaveAction = (close) ? 'save_and_close' : (saveAction || 'tab_change');
        $scope.$emit('CouponsCreateController::reset');
        this.isSubmitted = true;

        console.log('CouponsCreateDetailController::complete', this.model.name);

        if (this.isValid()) {
          if (this.model.resellerId) {
            this.model.companyName = '';
          }
          var trackedLimits = this.isRedemptionEnabled ? this.redemptionLimitsPayload : null;
          ApiService.coupons.update(this.buildUpdatePayload()).then(function(response) {
            self.success.refreshRedemptionState(response);
            successHandler(response);
            if (trackedLimits) {
              CouponRedemptionLimitsService.trackEditSaved(trackedLimits, trackedSaveAction);
            }
          }, errorHandler);
        }else if (this.errorMessage) {
          $scope.$emit('CouponsCreateController::error', {
            message:  this.errorMessage
          });
        }
      },

      onSaveError: function(response) {
        var self = $scope.couponsCreateDetail,
          description = CouponRedemptionLimitsService.describeSaveError(response, {
            orderRedemptionCount: self.model.orderRedemptionCount
          });

        self.redemptionLimitErrors = description.fieldErrors;
        if (description.isOrderLimitBelowCount && self.model.id) {
          self.refreshRedemptionState();
        }

        $scope.$emit('CouponsCreateController::error', {
          message: description.message
        });
      },

      success: {
        init: function(response) {},

        getCoupon: function(response) {
          var self = $scope.couponsCreateDetail;
          self.model = response.data.payload;
          self.model.resellerId = parseInt(response.data.payload.resellerId, 10);
          self.redemptionLimits = CouponRedemptionLimitsService.createForm(self.model);
          self.redemptionLimitErrors = {};
        },

        refreshRedemptionState: function(response) {
          var self = $scope.couponsCreateDetail,
            payload = response.data.payload || {};
          self.model.orderRedemptionCount = payload.orderRedemptionCount;
          self.model.redemptionStatus = payload.redemptionStatus;
          self.model.orderRedemptionLimit = payload.orderRedemptionLimit;
          self.model.ticketRedemptionLimit = payload.ticketRedemptionLimit;
          if (self.redemptionLimitErrors.order) {
            self.redemptionLimitErrors.order = CouponRedemptionLimitsService.orderLimitBelowCountMessage(
              payload.orderRedemptionCount
            );
          }
        },

        getCategories: function(response) {
          $scope.couponsCreateDetail.categories = response.data.payload.list;
        },

        getCoupons: function(response) {
          $scope.couponsCreateDetail.coupons = response.data.payload.list;
        },

        getCouponAccounts: function(response) {
          $scope.couponsCreateDetail.accounts = response.data.payload.list.map( function(account) {
            return account.company;
          });
        },

        complete: function(response) {
          var self = $scope.couponsCreateDetail;
          self.isSubmitted = true;
          $state.go(self.next, { couponId: response.data.payload.id });
        },

        saveAndClose: function(response) {
          $scope.couponsCreateDetail.isSubmitted = true;
          $scope.$emit('CouponsCreateController::success', {
            message: 'Successfully Saved!'
          });

          $scope.$emit('CouponsCreateController::transition', {
            state: 'application.coupons.list'
          });
        }
      },

      error: {
        init: function(response) {},

        getCoupon: function(response) {},

        refreshRedemptionState: function(response) {
          // The count could not be re-read after a 2063 rejection: keep the error, drop the stale number.
          var self = $scope.couponsCreateDetail,
            message = CouponRedemptionLimitsService.orderLimitBelowCountMessage(null);
          if (self.redemptionLimitErrors.order) {
            self.redemptionLimitErrors.order = message;
          }
          $scope.$emit('CouponsCreateController::error', {
            message: message
          });
        },

        getCategories: function(response) {},

        getCoupons: function(response) {},

        getCouponAccounts: function(response) {},

        complete: function(response) {
          $scope.couponsCreateDetail.onSaveError(response);
        },

        saveAndClose: function(response) {
          $scope.couponsCreateDetail.onSaveError(response);
        }
      }

    };

    $scope.couponsCreateDetail.init();

}]);